import { checklistDamages } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.DamageConstant';
import { Menu, Modal, ModalProps } from 'antd';

import './style.less';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onSelectDamage?: (damage: string) => void;
  onCancel: VoidFunction;
}

export default function ChecklistDamageModal(props: Props) {
  const checklistDamagesOptions = checklistDamages.map((damage, index) => ({
    key: damage.value,
    label: `${index + 1} - ${damage.label}`,
  }));

  return (
    <Modal
      title="Selecione a avaria"
      {...props}
      className="scroll checklist-damage-modal"
      closable={false}
      footer={null}
      destroyOnClose
    >
      <Menu
        style={{ maxHeight: 600, overflow: 'auto' }}
        items={checklistDamagesOptions}
        onSelect={(value) => {
          if (props.onSelectDamage) {
            props.onSelectDamage(value.key);
          }

          props.onCancel();
        }}
      />
    </Modal>
  );
}
